'use strict';
window._theme = window._theme || {};

const activateDeferredPageStyles = () => {
  if (!document.body) return;
  document.body.classList.add('dom-loaded');

  for (const link of document.querySelectorAll('link[data-defer]')) {
    link.media = 'all';
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', activateDeferredPageStyles, { once: true });
} else {
  activateDeferredPageStyles();
}

_theme.isMobile = jQuery(window).width() < 768 ? true : false;
_theme.isIpad = jQuery(window).width() < 1025 ? true : false;
_theme.isIpadAndUp = jQuery(window).width() > 767 ? true : false;
_theme.isLaptopAndUp = jQuery(window).width() > 1199.99 ? true : false;

_theme.getOS = function () {
  if (!window.navigator) return '';
  const userAgent = window.navigator.userAgent;
  const userAgentData = window.navigator.userAgentData;
  let platform = userAgentData
      ? userAgentData.platform
        ? userAgentData.platform
        : window.navigator.platform
      : window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'mac-os';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'ios';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'windows';
  } else if (/Android/.test(userAgent)) {
    os = 'android';
  } else if (/Linux/.test(platform)) {
    os = 'linux';
  }

  return os;
};

_theme.initSliderPlayPause = function ($parent, $sliderInstance, label) {
  if ($parent.length === 0 || $parent.find('.homepage-slider-play-pause').length === 0) return;

  const adaString =
    typeof window !== 'undefined' && window.accessibilityStrings ? window.accessibilityStrings : {};
  const pauseLabel = adaString.pauseSlideshow || 'Pause slideshow';
  const playLabel = adaString.playSlideshow || 'Play slideshow';

  $parent.find('.homepage-slider-play-pause').removeClass('hidden');
  const $playPausebutton = $parent.find('.homepage-slider-play-pause button');
  $playPausebutton.attr('aria-label', pauseLabel);

  $playPausebutton.on('click', function () {
    jQuery(this).toggleClass('active');
    jQuery(this).attr('aria-label', pauseLabel);
    if (jQuery(this).hasClass('active')) {
      jQuery(this).attr('aria-label', playLabel);
      if ($sliderInstance && $sliderInstance[0] && $sliderInstance[0].swiper) {
        $sliderInstance[0].swiper.autoplay?.stop();
      }
    } else {
      if ($sliderInstance && $sliderInstance[0] && $sliderInstance[0].swiper) {
        $sliderInstance[0].swiper.autoplay?.start();
      }
    }
  });
};

_theme.iPhoneVersion = function () {
  const iHeight = window.screen.height;
  const iWidth = window.screen.width;

  if (iWidth === 414 && iHeight === 896) {
    return 'xmax-xr';
  } else if (iWidth === 375 && iHeight === 812) {
    return 'x-xs';
  } else if (iWidth === 320 && iHeight === 480) {
    return '4';
  } else if (iWidth === 375 && iHeight === 667) {
    return '6';
  } else if (iWidth === 414 && iHeight === 736) {
    return '6-plus';
  } else if (iWidth === 320 && iHeight === 568) {
    return '5';
  } else if (iHeight <= 480) {
    return '2-3';
  }
  return 'none';
};

_theme.focusFirstTabbable = function ($container, tabbableAdditionalElems) {
  if (!$container || $container.length === 0) return;
  try {
    let tabbableElems = ['select', 'input', 'textarea', 'button', 'a'];
    if (tabbableAdditionalElems) {
      if (Array.isArray(tabbableAdditionalElems))
        tabbableElems = tabbableElems.concat(tabbableAdditionalElems);
      if (typeof tabbableAdditionalElems === 'string') tabbableElems.push(tabbableAdditionalElems);
    }
    const tabbable = $container.find(tabbableElems.join(',')).filter(':visible');
    tabbable.first().focus();
  } catch (err) {}
};

_theme.focusTrap = function (
  elem,
  cb,
  tabbableAdditionalElems,
  enableBackwardJourney,
  disableLinearNavigation,
  skipInitialFocus
) {
  // const isIos = document.documentElement.classList.contains('device--ios');
  let tabbableElems = ['select', 'input', 'textarea', 'button', 'a'];
  if (tabbableAdditionalElems) {
    if (Array.isArray(tabbableAdditionalElems))
      tabbableElems = tabbableElems.concat(tabbableAdditionalElems);
    if (typeof tabbableAdditionalElems === 'string') tabbableElems.push(tabbableAdditionalElems);
  }
  const tabbable = elem.find(tabbableElems.join(',')).filter(':visible');
  const firstTabbable = tabbable.first();
  const lastTabbable = tabbable.last();
  // console.log("reun",firstTabbable,"last",tabbable)
  if (!skipInitialFocus) {
    firstTabbable.focus();
  }
  // if(isIos) firstTabbable.dispatchEvent(new Event('touchstart'));

  lastTabbable.off('keydown').on('keydown', function (e) {
    if (disableLinearNavigation && e.key) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        return;
      }
    }

    if (e.which === 9 && !e.shiftKey) {
      e.preventDefault();
      firstTabbable.focus();
      // if(isIos) firstTabbable.dispatchEvent(new Event('touchstart'));
    }
  });

  firstTabbable.off('keydown').on('keydown', function (e) {
    if (disableLinearNavigation && e.key) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        return;
      }
    }

    if (e.which === 9 && e.shiftKey && !enableBackwardJourney) {
      e.preventDefault();
      lastTabbable.focus();
      // if(isIos) lastTabbable.dispatchEvent(new Event('touchstart'));
    }
  });

  elem.off('keydown').on('keydown', function (e) {
    if (disableLinearNavigation && e.key) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        return;
      }
    }

    if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
      cb(elem, e);
    }
  });
};

_theme.attributeSetter = function (el, attrs) {
  for (const key in attrs) {
    el.setAttribute(key, attrs[key]);
  }
};

_theme.attributeRemover = function attributeRemover(el, attrs) {
  for (const key of attrs) {
    el.removeAttribute(key);
  }
};

_theme.handleKeyboardUpDownButtonPress = function (evt) {
  const key = evt.key.toUpperCase();
  if (key === 'ARROWUP') {
    const $prevElem = $(this).prev();
    if ($prevElem.length) {
      $prevElem.addClass('selected').siblings().removeClass('selected');
      setTimeout(function () {
        $prevElem.focus();
      }, 250);
    }
  }

  if (key === 'ARROWDOWN') {
    const $nextElem = $(this).next();
    if ($nextElem.length) {
      $nextElem.addClass('selected').siblings().removeClass('selected');
      setTimeout(function () {
        $nextElem.focus();
      }, 250);
    }
  }

  if (key === 'TAB' && !evt.shiftKey) {
    const $nextElem = $(this).next();
    if ($nextElem.length === 0) evt.preventDefault();
  }

  if (key === 'ENTER' || (key === ' ' && evt.which === 32)) {
    evt.target.click();
  }
};

_theme.handleKeyboardEnterOrSpacePress = function (evt, activeUpDown, callback) {
  const key = evt.code ? evt.code.toUpperCase() : evt.key.toUpperCase();
  const target = evt.target;
  if (key === 'ENTER' || (key === ' ' && evt.which === 32)) {
    target.click();
    if (callback && typeof callback === 'function') callback();
  }

  if (!activeUpDown) return true;
  if (key === 'ARROWUP' && target.previousElementSibling) {
    target.previousElementSibling.focus();
    if (target.nextElementSibling) target.nextElementSibling.classList.remove('select');
    target.previousElementSibling.classList.add('select');
  }
  if (key === 'ARROWDOWN' && target.nextElementSibling) {
    target.nextElementSibling.focus();
    if (target.previousElementSibling) target.previousElementSibling.classList.remove('select');
    target.nextElementSibling.classList.add('select');
  }
};

_theme.toggleCustomerForm = function (show, callback) {
  if (show) {
    if (_theme.isMobile) {
      $('#log-in-form').closest('.halo_modal-custom.cm-log-in-form').removeAttr('aria-hidden');
      $('#log-in-form')
        .closest('.halo_modal-custom.cm-log-in-form')
        .siblings()
        .attr('aria-hidden', 'true');
    }

    $('#log-in-form').fadeIn();
    $('body').addClass('modal-open');
    $('.cm-log-in-form').css('display', 'block').addClass('show');
    $('.wrapper-overlay').removeClass('active');

    if (!$('#log-in-form').data('source')) {
      $('#log-in-form').attr('data-source', '#header-pc-login-modal-cta');
    }

    setTimeout(function () {
      _theme.focusTrap($('#log-in-form'), function (elem, evt) {
        if (callback && typeof callback === 'function') callback(elem, evt);
        else $('#log-in-form .close-modal').click();
      });
    }, 250);
  } else {
    if (_theme.isMobile) {
      $('#log-in-form')
        .closest('.halo_modal-custom.cm-log-in-form')
        .siblings()
        .removeAttr('aria-hidden');
    }
    $('body').removeClass('modal-open');
    $('.cm-log-in-form').css('display', 'none');
    $('.cm-log-in-form').removeClass('show');
    $('.wrapper-overlay').removeClass('active');
    $('#log-in-form').attr('tabindex', -1);
    const dataSource = $('#log-in-form').data('source');
    if (dataSource) {
      $(dataSource).focus();
      $('#log-in-form').removeAttr('data-source');
    } else {
      $("[data-toggle='modal'][data-target='#log-in-form']").first().focus();
    }
    window.location.hash = '';
  }
};

_theme.updateGWP = function (resp) {
  const gwpblock = document.querySelector('gwp-block');
  if (gwpblock && resp.sections && resp.sections.gwp) {
    const gwpblockInner = gwpblock.querySelector('.gwp-block');
    if (gwpblockInner && resp.item_count !== null && resp.item_count !== undefined) {
      if (resp.item_count === 0) {
        gwpblockInner.setAttribute('aria-hidden', true);
      } else {
        gwpblockInner.setAttribute('aria-hidden', false);
      }
    }

    const gwpBody = _theme.Helpers.stringToHTML(resp.sections.gwp);
    if (gwpBody) {
      const respGWPBlock = gwpBody.querySelector('gwp-block');
      gwpblock.innerHTML = respGWPBlock.innerHTML;
    }
  }
};

_theme.initListrakCartUpdateEvent = function () {
  if (!window._ltk) return;

  Shopify.getCart(function (cartjson) {
    let r = cartjson.items,
      u = {},
      i;
    if (r.length > 0) {
      for (i = 0; i < r.length; i++) {
        const t = r[i],
          f = _ltk.Shopify.GetSkuProperty(t.id, t.sku),
          e = t.title,
          o = t.quantity,
          s = t.final_price / 100,
          h = t.image,
          c = t.url;
        _ltk.SCA.AddItemWithLinks(f, o, s, e, h, c);
        i <= 9 && (u[t.variant_id] = t.quantity);
      }
      _ltk.SCA.Meta1 = cartjson.token;
      _ltk.SCA.CartLink = encodeURI(JSON.stringify(u).replace(/:/gi, '-')).replace(/,/gi, '%2C');
      _ltk.SCA.Submit();
    } else _ltk.SCA.ClearCart();
  });
};

_theme.tweakBVLayout = function () {
  const tabbableElems = ['select', 'input', 'textarea', 'button', '[role="button"]', 'a'];

  $('.swiper-slide').each(function () {
    const isHidden = JSON.parse(this.getAttribute('aria-hidden'));
    if (this.nodeName && tabbableElems.includes(this.nodeName.toLowerCase())) {
      if (isHidden) {
        this.setAttribute('tabindex', -1);
      } else {
        this.removeAttribute('tabindex');
      }
    }

    $(this)
      .find(tabbableElems.join(','))
      .each(function (item) {
        if (isHidden) {
          this.setAttribute('tabindex', -1);
        } else {
          this.removeAttribute('tabindex');
        }
      });
  });
};

_theme.Helpers = (function () {
  function setParamInURL(param, value, _url) {
    if (!_url) _url = window.location.href;
    const url = new URL(_url);
    const search_params = url.searchParams;
    search_params.set(param, value);
    search_params.set('page', 1);

    url.search = search_params.toString();
    const new_url = url.toString();

    return new_url;
  }
  function getParamFromURL(param, _url) {
    if (!_url) _url = window.location.href;

    const url = new URL(_url);
    const search_params = url.searchParams;
    const paramVal = search_params.get(param);

    return paramVal;
  }
  function deleteParamFromURL(param, _url) {
    if (!param) return null;
    if (!_url) _url = window.location.href;
    const url = new URL(_url);
    const search_params = url.searchParams;
    search_params.delete(param);
    const new_url = url.toString();
    return new_url;
  }
  function setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
  function getCookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
  function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  function changeLineItemQty(line, qty, viaId, successCB, errorCB) {
    // let data = "quantity="+ qty + "&line=" + line;
    let data = { quantity: qty, line: line, sections: 'gwp,minicart', sections_url: '/' };
    if (viaId) {
      data = { quantity: qty, id: line, sections: 'gwp,minicart', sections_url: '/' };
    }
    $.ajax({
      type: 'post',
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      success: function (data) {
        if (successCB && typeof successCB === 'function') successCB(data);
      },
      error: function (err) {
        _theme.Helpers.showNotification($.parseJSON(err.responseText).description);
        if (errorCB && typeof errorCB === 'function') errorCB(err);
      },
    });
  }

  function updateLineItems(updates, successCB, errorCB) {
    if (!updates) {
      return Promise.reject(null);
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (successCB && typeof successCB === 'function') successCB(cart);
      })
      .catch(function (error) {
        console.error('Error:', error);
        if (errorCB && typeof errorCB === 'function') errorCB(err);
      });
  }

  function goToPreviousPage() {
    window.history.back();
  }

  // Local Storage
  function setItemIntoLS(key, value) {
    if (typeof localStorage === 'undefined' || localStorage === null) return;
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
    return true;
  }
  function getItemFromLS(key) {
    if (typeof localStorage === 'undefined' || localStorage === null) return;
    const value = localStorage.getItem(key);
    return JSON.parse(value);
  }
  function removeItemFromLS(key) {
    if (typeof localStorage === 'undefined' || localStorage === null) return;
    localStorage.removeItem(key);
    return true;
  }

  // Session Storage
  function setItemIntoSS(key, value) {
    if (typeof sessionStorage === 'undefined' || sessionStorage === null) return;
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    sessionStorage.setItem(key, value);
    return true;
  }
  function getItemFromSS(key) {
    if (typeof sessionStorage === 'undefined' || sessionStorage === null) return;
    const value = sessionStorage.getItem(key);
    return JSON.parse(value);
  }
  function removeItemFromSS(key) {
    if (typeof sessionStorage === 'undefined' || sessionStorage === null) return;
    sessionStorage.removeItem(key);
    return true;
  }

  function showNotification(msg, delay) {
    const toastModel = document.querySelector('[data-toast-notify]');
    if (!msg || !toastModel) return;
    toastModel.querySelector('[data-toastmsg]').innerHTML = msg;
    toastModel.classList.add('active');

    setTimeout(function () {
      toastModel.classList.remove('active');
    }, delay || 3000);
  }

  function changeLineItemQty(line, qty, viaId, successCB, errorCB) {
    let data = { quantity: qty, line: line, sections: 'gwp,minicart', sections_url: '/' }; //"quantity="+ qty + "&line=" + line;
    if (viaId) {
      data = { quantity: qty, id: line, sections: 'gwp,minicart', sections_url: '/' };
    }
    jQuery.ajax({
      type: 'post',
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      success: function (data) {
        if (successCB && typeof successCB === 'function') successCB(data);
      },
      error: function (err) {
        _theme.Helpers.showNotification(err.responseJSON.message, 3000);

        // Reset ALL input values to their original values when there's an error
        const allInputs = document.querySelectorAll('[data-block-qty] input');
        allInputs.forEach(function (input) {
          const originalValue =
            input.getAttribute('data-value') || input.getAttribute('data-original-qty') || 10;
          input.value = originalValue;
        });
        if (errorCB && typeof errorCB === 'function') errorCB(err);
      },
    });
  }

  function addProductToCart(vid, qty, props, successCB, errorCB, hideLoader) {
    if (!vid) return;

    let properties = null;
    if (props && typeof props === 'string') properties = { _proType: props };
    if (props && typeof props === 'object') properties = props;

    jQuery.ajax({
      url: window.routes.cart_add_url + '.js',
      method: 'POST',
      beforeSend: function () {
        if (!hideLoader) _theme.toggleLoading(1);
      },
      data: {
        quantity: qty,
        id: vid,
        properties: properties,
        sections: 'gwp,minicart',
        sections_url: '/',
      },
      dataType: 'json',
      success: function (res) {
        try {
          const handle = res && res.handle;
          if (handle) {
            document.dispatchEvent(
              new CustomEvent('cart:item_added', { detail: { handle: handle } })
            );
          }
        } catch (e) {
          /* silent - never break the cart flow */
        }

        if (successCB && typeof successCB === 'function') successCB(res);
      },
      error: function (err) {
        _theme.Helpers.showNotification(jQuery.parseJSON(err.responseText).description);
        if (errorCB && typeof errorCB === 'function') errorCB(err);
      },
      complete: function () {
        _theme.toggleLoading();
      },
    });
  }

  function removeItemsFromCart(items) {
    if (!items || items.length === 0) return;

    const updates = {};
    items.forEach(function (vid) {
      updates[vid] = 0;
    });

    fetch('/cart/update.js', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        updates: updates,
      }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (res) {
        window.location.reload();
      })
      .catch(function (err) {
        console.log(err);
        _theme.Helpers.showNotification(jQuery.parseJSON(err.responseText).description);
      });
  }

  function handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-$/, '')
      .replace(/^-/, '');
  }

  function toggleLoader(show) {
    const loader = document.querySelector('.loading-modal');
    if (!loader) return;
    if (show) loader.classList.add('show');
    else loader.classList.remove('show');
  }

  function fetchOfferData() {
    return fetch('/cart?view=free-offers')
      .then(function (res) {
        return res.json();
      })
      .then(function (dd) {
        return dd;
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  function isNumberKey(evt) {
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) return false;

    return true;
  }

  function refreshKlarna() {
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
  }

  function updateHtml(html, str, data) {
    let newhtml = html;
    if (newhtml.indexOf(str) > -1) {
      newhtml = newhtml.replace(str, data);
      return this.updateHtml(newhtml, str, data);
    } else {
      return newhtml;
    }
  }

  function validateEmail(email) {
    if (!email) email = '';
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return email.match(regex);
  }

  function getFormattedDate(date) {
    if (!date) return '';
    const d = new Date(date);
    let dateVal = d.getDate();
    dateVal = dateVal >= 10 ? dateVal : '0' + dateVal;
    let month = d.getMonth() + 1;
    month = month >= 10 ? month : '0' + month;
    const formattedDate = month + '/' + dateVal + '/' + d.getFullYear();
    return formattedDate;
  }

  function getFormattedTime(date) {
    if (!date) return '';
    const d = new Date(date);
    let hours = d.getHours();
    let minutes = d.getMinutes();
    const timeLabel = hours < 12 ? 'AM' : 'PM';
    hours = hours <= 12 ? hours : hours - 12;
    hours = hours >= 10 ? hours : '0' + hours;
    minutes = minutes >= 10 ? minutes : '0' + minutes;
    const formattedTime = hours + ':' + minutes + ' ' + timeLabel;
    return formattedTime;
  }

  // with exception that this one handles context passing
  const throttle = (fn, ms = 300) => {
    let lastCall = Date.now() - 2 * ms;
    let result;
    let trailing;

    function invoke(...args) {
      lastCall = Date.now();
      return (result = fn.apply(this, args));
    }

    return function throttler(...args) {
      const now = Date.now();

      if (now - lastCall >= ms) {
        return invoke.apply(this, args);
      }

      clearTimeout(trailing);
      trailing = setTimeout(() => invoke.apply(this, args), lastCall - now + ms);

      return result;
    };
  };

  function isInViewport(element) {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function stringToHTML(str) {
    if (!str) return null;

    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }

  function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }

  function formatPrice(amount) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
      amount || 0
    );
  }

  function variantConverterOzToMl(ozNum) {
    if (!Number.isFinite(ozNum)) return null;

    const pairs = [
      [0.05, 1.5],
      [0.17, 5],
      [0.5, 15],
      [0.8, 25],
      [1.0, 30],
      [1.4, 40],
      [1.7, 50],
      [2.0, 60],
      [2.5, 75],
      [2.7, 80],
      [3.0, 90],
      [3.3, 100],
      [3.4, 100],
      [4.2, 125],
      [5.0, 150],
      [6.7, 200],
    ];

    for (const [oz, ml] of pairs) {
      if (Math.abs(ozNum - oz) < 1e-6) return ml;
    }

    return Math.floor(29.5735 * ozNum);
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  // EST/EDT Time Utility Functions
  function getESTOffset(date) {
    // EST = UTC-5 (300), EDT = UTC-4 (240)
    const year = date.getFullYear();

    // Find 2nd Sunday in March (DST start)
    const marchFirst = new Date(year, 2, 1);
    const marchFirstDay = marchFirst.getDay();
    const secondSundayMarch = 1 + ((7 - marchFirstDay) % 7) + 7;

    // Find 1st Sunday in November (DST end)
    const novemberFirst = new Date(year, 10, 1);
    const novemberFirstDay = novemberFirst.getDay();
    const firstSundayNovember = 1 + ((7 - novemberFirstDay) % 7);

    // Create dates for DST range
    const dstStart = new Date(year, 2, secondSundayMarch, 2); // 2 AM EST
    const dstEnd = new Date(year, 10, firstSundayNovember, 2); // 2 AM EDT

    // Check if date is within DST range
    const isDST = date >= dstStart && date < dstEnd;

    return isDST ? 240 : 300; // EDT: -4h, EST: -5h
  }

  function parseESTDate(dateStr, timeStr) {
    try {
      if (!dateStr || !timeStr) {
        return new Date(0);
      }

      let year, month, day;

      // Parse date string - handle both YYYY-MM-DD and "Month Day, Year" formats
      if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
        // YYYY-MM-DD format (e.g., "2025-10-21")
        const dateParts = dateStr.split('-');
        year = parseInt(dateParts[0], 10);
        month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed in Date
        day = parseInt(dateParts[2], 10);
      } else {
        // Try parsing as a date string (e.g., "July 2, 2025")
        const tempDate = new Date(dateStr);
        if (isNaN(tempDate.getTime())) {
          console.error('Invalid date format:', dateStr);
          return new Date(0);
        }
        year = tempDate.getFullYear();
        month = tempDate.getMonth();
        day = tempDate.getDate();
      }

      // Parse time string (e.g., "10:00 AM" or "1:17 PM")
      const timeMatch = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
      if (!timeMatch) {
        console.error('Invalid time format:', timeStr);
        return new Date(0);
      }

      let hours = parseInt(timeMatch[1], 10);
      const minutes = parseInt(timeMatch[2], 10);
      const ampm = timeMatch[3].toUpperCase();

      // Convert to 24-hour format
      if (ampm === 'PM' && hours !== 12) {
        hours += 12;
      } else if (ampm === 'AM' && hours === 12) {
        hours = 0;
      }

      // Create a date object to determine EST/EDT offset for this date
      const testDate = new Date(year, month, day, hours, minutes, 0);
      const estOffsetMinutes = getESTOffset(testDate);

      // Create date as if it's in EST/EDT timezone
      // We'll create it in local timezone, then adjust to represent EST/EDT
      const localDate = new Date(year, month, day, hours, minutes, 0);
      const localOffsetMinutes = localDate.getTimezoneOffset();

      // Convert EST/EDT time to UTC timestamp
      // UTC timestamp = local timestamp - localOffset + estOffset
      const utcTimestamp =
        localDate.getTime() - localOffsetMinutes * 60000 + estOffsetMinutes * 60000;

      return new Date(utcTimestamp);
    } catch (error) {
      console.error('Error parsing EST date:', error);
      return new Date(0);
    }
  }

  /**
   * Load a script once; returns a shared Promise per URL.
   * @param {string} src
   * @returns {Promise<void>}
   */
  function loadScript(src) {
    if (!src) return Promise.resolve();

    window._theme._scriptLoadPromises = window._theme._scriptLoadPromises || {};

    if (window._theme._scriptLoadPromises[src]) {
      return window._theme._scriptLoadPromises[src];
    }

    window._theme._scriptLoadPromises[src] = new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${src}"]`);

      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
          return;
        }

        existing.addEventListener('load', () => resolve(), { once: true });
        existing.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), {
          once: true,
        });
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.addEventListener(
        'load',
        () => {
          script.dataset.loaded = 'true';
          resolve();
        },
        { once: true }
      );
      script.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), {
        once: true,
      });
      document.head.appendChild(script);
    });

    return window._theme._scriptLoadPromises[src];
  }

  function getCurrentESTTime() {
    const now = new Date();

    // Get current time components in EST/EDT
    const estString = now.toLocaleString('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });

    // Parse EST string: "MM/DD/YYYY, HH:MM:SS"
    const estMatch = estString.match(/(\d{2})\/(\d{2})\/(\d{4}), (\d{2}):(\d{2}):(\d{2})/);
    if (estMatch) {
      const estMonth = parseInt(estMatch[1], 10) - 1;
      const estDay = parseInt(estMatch[2], 10);
      const estYear = parseInt(estMatch[3], 10);
      const estHours = parseInt(estMatch[4], 10);
      const estMinutes = parseInt(estMatch[5], 10);
      const estSeconds = parseInt(estMatch[6], 10);

      // Create date object representing EST time in local timezone
      const estDate = new Date(estYear, estMonth, estDay, estHours, estMinutes, estSeconds);

      // Get EST/EDT offset and local offset
      const estOffsetMinutes = getESTOffset(estDate);
      const localOffsetMinutes = estDate.getTimezoneOffset();

      // Convert EST/EDT time to UTC timestamp
      // Formula: UTC = localTimestamp - localOffset + estOffset
      const utcTimestamp =
        estDate.getTime() - localOffsetMinutes * 60000 + estOffsetMinutes * 60000;

      return utcTimestamp;
    }

    // Fallback: return current UTC time
    return now.getTime();
  }

  return {
    setParamInURL: setParamInURL,
    getParamFromURL: getParamFromURL,
    deleteParamFromURL: deleteParamFromURL,

    setCookie: setCookie,
    getCookie: getCookie,
    eraseCookie: eraseCookie,

    setItemIntoLS: setItemIntoLS,
    getItemFromLS: getItemFromLS,
    removeItemFromLS: removeItemFromLS,

    setItemIntoSS: setItemIntoSS,
    getItemFromSS: getItemFromSS,
    removeItemFromSS: removeItemFromSS,

    showNotification: showNotification,
    changeLineItemQty: changeLineItemQty,
    updateLineItems: updateLineItems,
    addProductToCart: addProductToCart,
    removeItemsFromCart: removeItemsFromCart,
    handleize: handleize,

    toggleLoader: toggleLoader,
    fetchOfferData: fetchOfferData,
    isNumberKey: isNumberKey,
    refreshKlarna: refreshKlarna,
    updateHtml: updateHtml,
    validateEmail: validateEmail,
    getFormattedDate: getFormattedDate,
    getFormattedTime: getFormattedTime,
    throttle: throttle,
    isInViewport: isInViewport,
    stringToHTML: stringToHTML,
    goToPreviousPage: goToPreviousPage,
    insertAfter: insertAfter,
    formatPrice: formatPrice,
    variantConverterOzToMl: variantConverterOzToMl,
    escapeHtml: escapeHtml,
    getESTOffset: getESTOffset,
    parseESTDate: parseESTDate,
    getCurrentESTTime: getCurrentESTTime,
    loadScript: loadScript,
  };
})();

/**
 * Full variant option line for UI ("1.7 oz / 50 ml") — uses _theme.Helpers.variantConverterOzToMl only.
 * Used when variant-picker updates labels, product-info sync, and quickview-dialog (initial HTML from JSON;
 * that path has no Liquid, so it cannot rely on variant-picker-component.js alone).
 */
_theme.formatVariantPickerOptionLabel = function (optionValue) {
  if (optionValue == null) return '';

  const s = String(optionValue).trim();
  if (!s) return '';

  const lower = s.toLowerCase();
  if (!lower.includes('oz')) return s;

  const beforeOz = s.split(/oz/i)[0];
  const ozNum = parseFloat(String(beforeOz).trim());
  if (!Number.isFinite(ozNum)) return s;

  const ml =
    _theme.Helpers && typeof _theme.Helpers.variantConverterOzToMl === 'function'
      ? _theme.Helpers.variantConverterOzToMl(ozNum)
      : null;

  if (ml == null || !Number.isFinite(ml)) return s;

  return `${s} / ${ml} ml`;
};
